
<template>
    <v-data-table locale="de-DE" :headers="tableHeaders" :items="tableItems" dense hide-default-footer :items-per-page="1000" style="height: 150px; overflow-y: auto">

        <template v-slot:item="props">
            <tr>
            <td style="height: 25px" class="text-left"><input style="text-align:left; width: 140px" type="text" v-model.lazy="props.item.name"></td>
            <td style="height: 25px" class="text-right"><input style="text-align:right; width: 140px" type="text" v-model.lazy="props.item.Emodul" @blur="$store.dispatch('resetAndRedraw')"></td>            
            <td style="height: 25px" class="text-right"><input style="text-align:right; width: 140px" type="text" v-model.lazy="props.item.Wichte" @blur="$store.dispatch('resetAndRedraw')"></td>
            <td><v-icon color="red" small @click="deleteItem(props.item)">clear</v-icon></td>
            </tr>
        </template>  

        <template v-slot:body.prepend>
            <tr style="background: #C8E6C9">
                <td style="height: 25px" class="text-left"><input style="text-align:left; width: 140px" type="text" v-model.lazy="nMaterial.name"></td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 140px;" type="text" v-model.lazy="nMaterial.Emodul" ></td>            
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 140px;" type="text" v-model.lazy="nMaterial.Wichte"></td>
                <td><v-btn small icon @click="apply()"><v-icon color="green" small>add_box</v-icon></v-btn></td>
            </tr>
        </template>                  
    </v-data-table>
</template>

<script>
import Material from '../../js/Material'
/* eslint-disable */

export default {
    data(){
        return{
            nMaterial: new Material,
            tableHeaders: [
                    { text: 'Name', align: 'left', value: 'Name'},
                    { text: 'E-Modul', align: 'right', sortable: false, value: 'Emodul'},
                    { text: 'Wichte', align: 'right', sortable: false, value: 'Wichte'}
                ],
        }
    },
    computed: {
        tableItems() { return this.$store.state.StatikSystem.Materialliste},
    },
    methods: {
        apply(){
            if (this.nMaterial.Emodul <= 0) return
            this.$store.state.newMaterial = true
            this.$store.commit('MaterialDialogApply', this.nMaterial)
            this.nMaterial = new Material
        },
        deleteItem(payload){
            this.$store.commit('MaterialDialogDelete',payload)
        }
    }
}
</script>

<style scoped>
    select {
        padding-left: 5px; 
        padding-right: 5px;
        cursor: pointer;
        border-style: solid;
    }
    input {
        cursor: pointer;
        border-style: solid;
        border-width: thin;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 25px;
    }   
</style>